import * as React from 'react';

import { Radio } from '@components/common';

import { DropdownProps } from '../../types';

type Props<D = any> = DropdownProps<D, string | undefined>;

interface QualificationOption {
  label: string;
  value: string;
}

export const QUALIFICATION_STATUS_OPTIONS: QualificationOption[] = [
  { label: 'Qualified', value: 'qualified' },
  { label: 'Partial', value: 'partial' },
  { label: 'Disqualified', value: 'disqualified' },
  { label: 'No data', value: 'no_data' }
];

export const QualificationStatus: React.FC<React.PropsWithChildren<Props<string | undefined>>> = ({
  value,
  onChange
}) => {
  return (
    <div className='space-y-1.5'>
      {QUALIFICATION_STATUS_OPTIONS.map((option) => (
        <div className='flex' key={option.value}>
          <Radio
            id={option.value}
            checked={value === option.value}
            type='radio'
            value={option.value}
            label={option.label}
            onChange={() => onChange({ value: option.value, allowNotSet: true })}
          />
        </div>
      ))}
    </div>
  );
};
